import { PoiDetailsCompanyOutput } from './poi-details-company-output.model';
import { PoiDetailsBranchOutput } from './poi-details-branch-output.model';


export class PoiDetailsOutputWithOutStatus implements IPoiDetailsOutputWithOutStatus {
    /** The auto-generated id of the poi details master */
    poi_details_id!: number;
    /** The auto-generated id of the company details master */
    reseller_company_id!: number;
    /** The company type should be All or Selected */
    company_type!: string;
    /** The branch type should be All or Selected */
    branch_type!: string;
    /** The place name with 255 character limit */
    place_name!: string;
    /** The latitude of selected place */
    latitude!: number;
    /** The longitude of selected place */
    longitude!: number;
    /** The tolerance of selected place */
    tolerance!: number;
    /** The auto generated id from poi type master */
    poi_type_id!: number;
    /** The description with 5000 character limit */
    description!: string;
    /** The street1 with 255 character limit */
    street_1!: string;
    /** The street2 with 255 character limit */
    street_2!: string;
    /** The zip code with 6 character limit */
    zip_code!: string;
    /** The auto generated id from city master */
    city_id!: number;
    /** The auto generated id from state master */
    state_id!: number;
    /** The auto generated id from country master */
    country_id!: number;
    /** The auto generated id from company details master */
    company_details_id!: number;
    /** The auto generated id from branch details master */
    branch_detail_id!: number;
    selected_company_data!: PoiDetailsCompanyOutput[];
    selected_branch_data!: PoiDetailsBranchOutput[];
    status!: number;

    constructor(data?: IPoiDetailsOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poi_details_id = _data["poi_details_id"];
            this.reseller_company_id = _data["reseller_company_id"];
            this.company_type = _data["company_type"];
            this.branch_type = _data["branch_type"];
            this.place_name = _data["place_name"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.tolerance = _data["tolerance"];
            this.poi_type_id = _data["poi_type_id"];
            this.description = _data["description"];
            this.street_1 = _data["street_1"];
            this.street_2 = _data["street_2"];
            this.zip_code = _data["zip_code"];
            this.city_id = _data["city_id"];
            this.state_id = _data["state_id"];
            this.country_id = _data["country_id"];
            this.company_details_id = _data["company_details_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            if (Array.isArray(_data["selected_company_data"])) {
                this.selected_company_data = [] as any;
                for (let item of _data["selected_company_data"])
                    this.selected_company_data!.push(PoiDetailsCompanyOutput.fromJS(item));
            }
            if (Array.isArray(_data["selected_branch_data"])) {
                this.selected_branch_data = [] as any;
                for (let item of _data["selected_branch_data"])
                    this.selected_branch_data!.push(PoiDetailsBranchOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PoiDetailsOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PoiDetailsOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poi_details_id"] = this.poi_details_id;
        data["reseller_company_id"] = this.reseller_company_id;
        data["company_type"] = this.company_type;
        data["branch_type"] = this.branch_type;
        data["place_name"] = this.place_name;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["tolerance"] = this.tolerance;
        data["poi_type_id"] = this.poi_type_id;
        data["description"] = this.description;
        data["street_1"] = this.street_1;
        data["street_2"] = this.street_2;
        data["zip_code"] = this.zip_code;
        data["city_id"] = this.city_id;
        data["state_id"] = this.state_id;
        data["country_id"] = this.country_id;
        data["company_details_id"] = this.company_details_id;
        data["branch_detail_id"] = this.branch_detail_id;
        if (Array.isArray(this.selected_company_data)) {
            data["selected_company_data"] = [];
            for (let item of this.selected_company_data)
                data["selected_company_data"].push(item.toJSON());
        }
        if (Array.isArray(this.selected_branch_data)) {
            data["selected_branch_data"] = [];
            for (let item of this.selected_branch_data)
                data["selected_branch_data"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IPoiDetailsOutputWithOutStatus {
    /** The auto-generated id of the poi details master */
    poi_details_id: number;
    /** The auto-generated id of the company details master */
    reseller_company_id: number;
    /** The company type should be All or Selected */
    company_type: string;
    /** The branch type should be All or Selected */
    branch_type: string;
    /** The place name with 255 character limit */
    place_name: string;
    /** The latitude of selected place */
    latitude: number;
    /** The longitude of selected place */
    longitude: number;
    /** The tolerance of selected place */
    tolerance: number;
    /** The auto generated id from poi type master */
    poi_type_id: number;
    /** The description with 5000 character limit */
    description: string;
    /** The street1 with 255 character limit */
    street_1: string;
    /** The street2 with 255 character limit */
    street_2: string;
    /** The zip code with 6 character limit */
    zip_code: string;
    /** The auto generated id from city master */
    city_id: number;
    /** The auto generated id from state master */
    state_id: number;
    /** The auto generated id from country master */
    country_id: number;
    /** The auto generated id from company details master */
    company_details_id: number;
    /** The auto generated id from branch details master */
    branch_detail_id: number;
    selected_company_data: PoiDetailsCompanyOutput[];
    selected_branch_data: PoiDetailsBranchOutput[];
    status: number;
}

